export interface SummaryDetails {
  numberOfOneStarRatings: number;
  numberOfTwoStarRatings: number;
  numberOfThreeStarRatings: number;
  numberOfFourStarRatings: number;
  numberOfFiveStarRatings: number;
}

export interface RatingSummary {
  ratingAverage: number;
  ratingCount: number;
  isRateable: boolean;
  bestRating: number;
  worstRating: number;
  summaryDetails: SummaryDetails;
}

export type RatingSummaryOverlay = Omit<RatingSummary, 'reviewList' | 'isRateable' | 'bestRating' | 'worstRating'>;

export const defaultRating: RatingSummary = {
  ratingAverage: 0,
  ratingCount: 0,
  isRateable: false,
  bestRating: 1,
  worstRating: 1,
  summaryDetails: {
    numberOfOneStarRatings: 0,
    numberOfTwoStarRatings: 0,
    numberOfThreeStarRatings: 0,
    numberOfFourStarRatings: 0,
    numberOfFiveStarRatings: 0,
  },
};

export const defaultRatingOverlay: RatingSummaryOverlay = {
  ratingAverage: 5,
  ratingCount: 316,
  summaryDetails: {
    numberOfOneStarRatings: 0,
    numberOfTwoStarRatings: 21,
    numberOfThreeStarRatings: 43,
    numberOfFourStarRatings: 65,
    numberOfFiveStarRatings: 187,
  },
};
